/**
 * Method for merging all routes from different modules
 * @param {Array} routes - {public: [], auth: []} list of all routes per modules
 * @returns {Array}
 */
function combineRoutes(routes) {
  const routeList = { public: [], auth: [] };

  routes.forEach((route) => {
    // eslint-disable-next-line no-prototype-builtins
    if (route.hasOwnProperty('public')) {
      routeList.public = [...routeList.public, ...route.public];
    }

    // eslint-disable-next-line no-prototype-builtins
    if (route.hasOwnProperty('auth')) {
      routeList.auth = [...routeList.auth, ...route.auth];
    }
  });

  return routeList;
}

export default { combineRoutes };
